import { Component, inject, OnInit } from '@angular/core';
import { UpdateService } from '@/common/update.service';

@Component({
	selector: 'app-update-banner',
	templateUrl: './update-banner.component.html',
})
export class UpdateBannerComponent implements OnInit {
	readonly updateService = inject(UpdateService);

	ngOnInit(): void {
		this.updateService.start();
	}
}
